import { PRISMIC_TYPES } from '~/lib/prismic-types'

import getCategoryPageStaticPropsFunction from '~/data/category-page-data'
import { getStaticPathsFunction } from '~/data/page-data'

import CategoryFragrance from '../'

export default CategoryFragrance

export const getStaticProps = getCategoryPageStaticPropsFunction(
  PRISMIC_TYPES.CATEGORY_FRAGRANCE_V2,
)

export const getStaticPaths = getStaticPathsFunction({
  type: PRISMIC_TYPES.CATEGORY_FRAGRANCE_V2,
})
